<template>
  <v-menu transition="slide-y-transition" offset-y bottom :content-class="contentClass" :min-width="minWidth">
    <template v-slot:activator="{ on: menu }">
      <slot name="activator" :menu="menu"></slot>
    </template>
    <v-list class="ma-0" style="padding: 12px 0;">
      <v-layout column align-center>
        <slot name="list-menu" />
      </v-layout>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'ListButton',
  props: {
    minWidth: {
      type: String,
      required: false,
      default: '200'
    },
    contentClass: {
      type: String,
      required: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_molecules/buttons/ListButton.vue